var $73c8bf6e1582084f$exports = {};
$73c8bf6e1582084f$exports = {
    "clear": `\u{6E05}\u{9664}`,
    "invalid": `(\u{7121}\u{6548})`,
    "loading": `\u{6B63}\u{5728}\u{8F09}\u{5165}...`,
    "noResults": `\u{7121}\u{4EFB}\u{4F55}\u{7D50}\u{679C}`,
    "valid": `(\u{6709}\u{6548})`
};


export {$73c8bf6e1582084f$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
